module.exports = __webpack_public_path__ + "img/feng.cffd8908.gif";